import { useEffect } from 'react'
import { UseGetListOptions } from '@/service-library/core-hooks/useGetList'
import { useGetOrganizations } from '@/service-library/hooks/organizations'
import { Organization } from '@/types/organizations'

export default function useAllOrganizations(
  options: UseGetListOptions<Organization> = {},
) {
  const query = useGetOrganizations({
    ...options,
    filters: {
      limit: '500',
      ordering: '-parent_org_id,name,id',
      ...options.filters,
    },
  })
  const { hasNextPage, isFetching, isRefetching, fetchNextPage, isPending } =
    query

  const fetchData = options.enabled || options.enabled === undefined
  const isFetchingAll =
    (fetchData && isPending) || hasNextPage || (isFetching && !isRefetching)

  useEffect(() => {
    if (fetchData && hasNextPage && !isFetching) {
      fetchNextPage()
    }
  }, [fetchData, fetchNextPage, hasNextPage, isFetching, options.enabled])

  return { isFetchingAll, ...query }
}
